const domainAppMap = {
	batens_verden: 'b-v.no',
	storbatmagasinet: 'storbatmag.no',
	batglede: 'baatglede.no',
	seilas: 'seilas.no',
	pers_utleie: 'pers.b-v.no',
}

module.exports = domainAppMap